import React, { useContext } from 'react'

import { useSelectedCurrency } from '../../../hooks/useSelectedCurrency'
import { LocaleContext } from '../../../locale/i18n'
import { PriceWithCurrency } from '../../../locale/PriceWithCurrency'
import { Product } from '../../../logic/catalog'
import {
  getEstimatedPrice,
  getSamplePrice,
  serviceFeeCentsPerCurrency,
} from '../../../logic/price'
import PriceGroup from '../../PriceGroup'

import './PricingBreakdown.scss'

interface Props {
  product: Product
  parameters?: Record<string, string | undefined>
}

const PricingBreakdown = ({ product, parameters = {} }: Props) => {
  const { interpolate, locale, t } = useContext(LocaleContext)
  const { currency } = useSelectedCurrency()
  const fixedPrice = getSamplePrice({
    currency,
    parameters,
    product,
  })
  const estimatedPriceRange = getEstimatedPrice(product, currency)

  const price =
    product.websitePricingModel === 'fixed' ? fixedPrice : estimatedPriceRange

  return (
    <div className="pricingBreakdown">
      {price !== null && (
        <PriceGroup
          label={
            product.websitePricingModel === 'fixed'
              ? t('pricing.pricePerSample')
              : !product.estimatedPrice?.maxCents
                ? t('pricing.startingFrom')
                : t('pricing.priceRange')
          }
          price={price}
          note={typeof price !== 'number' ? t('pricing.perSample') : undefined}
          testId="productCTABannerFirstSample"
        />
      )}
      <div className="pricingBreakdown__note">
        <p>
          {interpolate('productPage.productConfiguration.serviceFee', {
            b: text => (
              <strong>
                <PriceWithCurrency
                  locale={locale}
                  price={serviceFeeCentsPerCurrency[currency] / 100}
                />{' '}
                {text}
              </strong>
            ),
          })}
        </p>
        <p>{t('productPage.productConfiguration.quantityDiscount')}</p>
      </div>
    </div>
  )
}

export default PricingBreakdown
